import { AppState } from 'redux/reducers';

import { MetaPage } from './type';

export const getPageMetaContent = (page: MetaPage | string | null) => (state: AppState) =>
  page ? state.meta.meta?.[page] ?? null : null;

export const getMetaPageId = ({ meta }: AppState) => meta.pageId;
